<template>
  <loading-icon class="c-card c-card--target" v-if="loading"></loading-icon>
  <section class="c-card c-card--target t-target" v-else>



    <div class="c-card--target__infographic">

      <div class="c-card--target__infographic__chart">
        <svg class="c-card--target__infographic__chart__svg" viewBox="-1 -1 2 2">
          <circle class="c-card--target__infographic__chart__spectrum t-target__spectrum" cx="0" cy="0" r=".8" />
          <circle class="c-card--target__infographic__chart__progress t-target__progress" cx="0" cy="0" r=".8"
                  v-bind:class="animateGauge" />
        </svg>
      </div>

      <div class="c-card--target__infographic__percentage">
        <p class="c-card--target__infographic__percentage__number t-target__percentage">{{ percentage + '%' }}</p>
      </div>

    </div>



    <div v-if="targetAmount !== 0" class="c-card--target__details">

      <h2 class="c-card--target__details__title t-headline">{{ title }}</h2>

      <h3 class="c-card--target__details__progress">
        <div v-bind:class="{ 'c-card--target__details__progress__numerator--currency': isCurrency }" class="c-card--target__details__progress__numerator t-target__numerator">
          <span v-if="isCurrency">$</span><vue-numeric separator="," v-bind:precision="0"
          :read-only="true" :value="progressAmount"></vue-numeric>
        </div>
        <div class="c-card--target__details__progress__denominator t-target__denominator">
          <i>of</i>
          <span v-if="isCurrency">$</span><vue-numeric separator="," v-bind:precision="0"
          :read-only="true" :value="targetAmount"></vue-numeric>
        </div>
      </h3>

    </div>



    <div v-else class="c-card--target__details">

      <h2 class="c-card--target__details__title t-headline">{{ title }}</h2>
      <h3 class="c-card--target__details__progress">
        <span class="c-card--target__details__progress__not-set t-target__numerator">
          {{ $t('web.card_target.target_not_set') }}
        </span>
      </h3>

    </div>



  </section>
</template>





<script>
import VueNumeric from 'vue-numeric'
import { mapGetters } from 'vuex'

export default {
  props: ['card'],
  components: {
    'vue-numeric': VueNumeric
  },
  computed: {
    ...mapGetters({
      websiteConfig: 'websiteConfig'
    }),
    loading () {
      return !this.card.cardLoaded
    },
    title () {
      return this.card.title
        ? this.card.title
        : this.$t('web.card_target.default_title')
    },
    targetAmount () {
      return this.card.target ? this.card.target : 0
    },
    progressAmount () {
      return this.card.progress ? this.card.progress : 0
    },
    percentage () {
      if (this.targetAmount !== 0) {
        return Math.floor((this.progressAmount / this.targetAmount) * 100)
      } else {
        return 0
      }
    },
    isCurrency () {
      return this.websiteConfig.metadata.Participant[this.card.target_mapping].type === 'currency'
    },
    animateGauge () {
      // applies a class which uses CSS to animate
      if (this.percentage <= 100) {
        return 'gauge-percent-' + this.percentage
      } else if (this.percentage > 100) {
        return 'gauge-percent-' + 100
      }
    }
  }
}
</script>

<style lang="sass" scoped>

</style>



// WEBPACK FOOTER //
// Target.vue?f372339c